var _path, _path2, _rect, _rect2, _path3, _rect3, _rect4, _ellipse, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHousingProtectServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 113,
    viewBox: "0 0 111 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.251 53.0155L90.9025 14.5635L65.9102 44.1677V113.001H110.251V53.0155Z",
    fill: "#5E676F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.873047 51.4756H68.8629V112.999H0.873047V51.4756Z",
    fill: "#98A1A9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5195,
    y: 69.9355,
    width: 17.7365,
    height: 18.457,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83.6445,
    y: 76.0859,
    width: 14.7804,
    height: 36.9139,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6171 14.5635H24.0431L0.873047 51.4774H68.8629L90.6171 14.5635Z",
    fill: "#1F2E3D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2969,
    y: 29.3418,
    width: 55.8813,
    height: 46.7461,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56.7754,
    y: 46.918,
    width: 6.9176,
    height: 19.5735,
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.237,
    cy: 46.9177,
    rx: 7.97724,
    ry: 7.97724,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7363 35.3555V12C43.7363 7.02944 47.7658 3 52.7363 3H67.7349C72.7054 3 76.7349 7.02944 76.7349 12V35.3555",
    stroke: "#D9D9D9",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHousingProtectServiceMain);
export default __webpack_public_path__ + "static/media/IcHousingProtectServiceMain.76ad9e719ee8698fe818e4c258eca626.svg";
export { ForwardRef as ReactComponent };